import React, { useEffect } from "react";
import useSidebar from "zustand-store/sidebar";
import { Link, useLocation } from "react-router-dom";
import { NON_DASHBOARD_PAGES, SIDEBAR_ITEMS } from "enums";
import { ReactComponent as ToggleIcon } from "assets/svgs/menu-toggle.svg";
import ProfileDropdown from "./profile-dropdown";

const Sidebar = () => {
  const location = useLocation();
  const { isOpen, setIsOpen } = useSidebar();

  const hideMenu = NON_DASHBOARD_PAGES.includes(location.pathname);
  const activeClass = "bg-white border-l-4 border-solid border-[#243b68]";

  const paymentStatusPage = ["/payment"].includes(location.pathname);

  useEffect(() => {
    if (hideMenu) {
      setIsOpen(true);
    }
  }, [hideMenu, setIsOpen]);

  if (paymentStatusPage || hideMenu) {
    return <></>;
  }

  return (
    <div className="hidden lg:block">
      <div
        className={`bg-primary h-screen max-h-screen transition-all duration-200 pt-5 fixed top-0 left-0 flex flex-col z-20 ${
          !isOpen ? "w-[80px]" : "w-[240px]"
        }`}
      >
        {/* Logo Section */}
        {isOpen && (
          <Link to={"/"} className="px-5 mb-8">
            <img
              alt="logo"
              src={`/logo-name.png`}
              className="w-[75%] max-w-[180px]"
            />
          </Link>
        )}

        {/* Collapsed Toggle */}
        {!isOpen && (
          <button
            onClick={() => setIsOpen(true)}
            className="z-10 mb-8 mx-auto hover:opacity-80 transition-opacity"
            aria-label="Expand sidebar"
          >
            <ToggleIcon />
          </button>
        )}

        {/* Navigation Items */}
        <div className="flex-1 overflow-y-auto scrollbar-thin">
          {!hideMenu && (
            <nav>
              <ul className="space-y-0.5">
                {SIDEBAR_ITEMS(isOpen).map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className={`flex items-center gap-3 py-3 transition-all hover:bg-white/90 ${
                        isOpen ? "pl-6 pr-4" : "justify-center"
                      } ${
                        location.pathname === item.to
                          ? activeClass
                          : "border-l-4 border-solid border-transparent"
                      }`}
                      title={!isOpen ? item.label : undefined}
                    >
                      <span className={`flex-shrink-0`}>
                        {item.icon}
                      </span>
                      <span
                        className={`text-base font-medium overflow-hidden whitespace-nowrap transition-all ${
                          isOpen ? "w-auto opacity-100" : "w-0 opacity-0"
                        }`}
                      >
                        {item.label}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>

        {/* Bottom Section - Only when expanded */}
        {!hideMenu && isOpen && (
          <div className="flex-shrink-0 border-t border-grey2/30">
            {/* Profile Dropdown */}
            <div className="px-4 py-3">
              <ProfileDropdown />
            </div>
          </div>
        )}

        {/* Collapse Toggle - Only when expanded */}
        {!hideMenu && isOpen && (
          <button
            onClick={() => setIsOpen(false)}
            className="bg-primary rounded-br-2xl rounded-tr-2xl px-2 py-2 absolute -right-[54px] md:right-4 z-10 top-[10px] hover:opacity-80 transition-opacity"
            aria-label="Collapse sidebar"
          >
            <ToggleIcon />
          </button>
        )}
      </div>
    </div>
  );
};

export default Sidebar;